module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/exchange-rate/exchange-rate.component.css
// module id = ./src/app/exchange-rate/exchange-rate.component.css
// module chunks = main